"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import * as Aria from 'react-aria-components';
import { TextFieldBase } from '../TextFieldBase/TextFieldBase.mjs';
import styles from './TextArea.module.scss.mjs';
import { ClearPropsContext } from '../ClearPropsContext/ClearPropsContext.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import { mergeRefs } from '@react-aria/utils';
import { ReactAriaControlledValueFix } from '../../lib/react/ReactAriaControlledValueFix.mjs';

const TextArea = flowComponent("TextArea", (props) => {
  const {
    children,
    placeholder,
    defaultValue,
    rows = 5,
    autoResizeMaxRows = rows,
    ref,
    ...rest
  } = props;
  const localRef = useRef(null);
  const getHeight = (rows2) => {
    return `calc(var(--line-height--m) * ${rows2} + (var(--form-control--padding-y) * 2))`;
  };
  const updateHeight = () => {
    if (localRef.current && rows !== autoResizeMaxRows) {
      localRef.current.style.height = "0px";
      const scrollHeight = localRef.current.scrollHeight;
      localRef.current.style.height = scrollHeight + "px";
    }
  };
  const input = /* @__PURE__ */ jsx(
    ReactAriaControlledValueFix,
    {
      inputContext: Aria.TextAreaContext,
      props,
      children: /* @__PURE__ */ jsx(
        Aria.TextArea,
        {
          rows,
          placeholder,
          className: styles.textArea,
          ref: mergeRefs(localRef, ref),
          onChange: updateHeight,
          defaultValue,
          style: {
            minHeight: getHeight(rows),
            maxHeight: getHeight(autoResizeMaxRows)
          }
        }
      )
    }
  );
  return /* @__PURE__ */ jsx(ClearPropsContext, { children: /* @__PURE__ */ jsx(TextFieldBase, { ...rest, input, children }) });
});

export { TextArea, TextArea as default };
//# sourceMappingURL=TextArea.mjs.map
